export default {
      id: "sli-search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-search",
      toString: function () {
        return this.url;
      }
    }